import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import Spinner from '../Spinner';
import { memberPropertiesType } from '../../types';
import { MEMBER_DETAIL, ON_MEMBER_CHANGED } from '../../graphql/members';
import MemberDetailTab from './MemberDetailTab';
import Error from '../errors/Error';

MemberDetail.propTypes = {
    id: PropTypes.number.isRequired,
    memberProps: memberPropertiesType.isRequired,
};

function MemberDetail(props) {
    const {
        id,
        memberProps,
    } = props;
    const variables = useMemo(() => ({
        id,
    }), [id]);
    const {
        loading,
        error,
        data,
        refetch,
    } = useExtendedQuery(MEMBER_DETAIL, {
        variables,
        variablesToUrl: false,
    });
    useExtendedSubscription(ON_MEMBER_CHANGED, {
        refetch,
        refetchVariables: variables,
        dataProperty: 'memberChanged',
    });
    let result;
    if (loading) {
        result = <Spinner className="member-detail-loading" />;
    } else if (error) {
        result = <Error className="member-detail-error" error={error} />;
    } else {
        result = (
            <MemberDetailTab
                member={data.memberDetail}
                memberProps={memberProps}
            />
        );
    }
    return result;
}

export default MemberDetail;
